import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('ui.components.DigitalClock', {
    hours: '{hours, plural, one {1 hour} other {# hours}}',
    minutes: '{minutes, plural, one {1 minute} other {# minutes}}',
});
